import { createContext } from 'react';
export const ContainerContext = /*#__PURE__*/createContext(undefined);